import {defineTokens} from '@chakra-ui/react3'

const chakraSpacing = defineTokens.spacing({
    0.5: {value: '0.125rem'},
    1: {value: '0.25rem'},
    1.5: {value: '0.375rem'},
    2: {value: '0.5rem'},
    2.5: {value: '0.625rem'},
    3: {value: '0.75rem'},
    3.5: {value: '0.875rem'},
    4: {value: '1rem'},
    4.5: {value: '1.125rem'},
    5: {value: '1.25rem'},
    6: {value: '1.5rem'},
    7: {value: '1.75rem'},
    8: {value: '2rem'},
    9: {value: '2.25rem'},
    10: {value: '2.5rem'},
    11: {value: '2.75rem'},
    12: {value: '3rem'},
    14: {value: '3.5rem'},
    16: {value: '4rem'},
    20: {value: '5rem'},
    24: {value: '6rem'},
    28: {value: '7rem'},
    32: {value: '8rem'},
    36: {value: '9rem'},
    40: {value: '10rem'},
    44: {value: '11rem'},
    48: {value: '12rem'},
    52: {value: '13rem'},
    56: {value: '14rem'},
    60: {value: '15rem'},
    64: {value: '16rem'},
    72: {value: '18rem'},
    80: {value: '20rem'},
    96: {value: '24rem'}
})

const leapSpacing = defineTokens.spacing({
    'spacing-0': {value: '0rem'},
    'spacing-2': {value: '0.125rem'},
    'spacing-4': {value: '0.25rem'},
    'spacing-6': {value: '0.375rem'},
    'spacing-8': {value: '0.5rem'},
    'spacing-10': {value: '0.625rem'},
    'spacing-12': {value: '0.75rem'},
    'spacing-16': {value: '1rem'},
    'spacing-20': {value: '1.25rem'},
    'spacing-24': {value: '1.5rem'},
    'spacing-32': {value: '2rem'},
    'spacing-40': {value: '2.5rem'},
    'spacing-48': {value: '3rem'},
    'spacing-64': {value: '4rem'},
    'spacing-80': {value: '5rem'},
    'spacing-90': {value: '5.625rem'},
    'spacing-128': {value: '8rem'},
    'spacing-160': {value: '10rem'},
    'container-padding-mobile': {value: '1.5rem'},
    'container-padding-desktop': {value: '5.625rem'},
    // Accordion-specific tokens - should be raised with designers for Figma token creation
    'accordion-left-heading-padding-right': {value: '108px'}
})

export const spacing = defineTokens.spacing({
    ...chakraSpacing,
    ...leapSpacing
})
